import React from 'react';
import ImageButton from '../common/input/ImageButton/index';
import VideoButton from '../common/input/VideoButton/index';
import Button from '../common/input/Button/index';
import FocusMenu from '../common/sections/MenuSection/index';
import PageIntroduction from '../common/sections/IntroductionSection/index';
import GridLayout from '../common/GridLayout/index';
import MediaObject from './MediaObject';

export default class HomePage extends React.Component {

    constructor(props) {
        super(props);
        this.state = {
            activeVideo: {
                id: null,
                time: null,
                counter: 1 // brukes til å "force-reload" av iframe
            }
        };
    }

    render() {
        return (
            <div>
                <PageIntroduction>
                    Dette er en side om klassifisering av helseforskning med Health Research Classification System &mdash; HRCS.
                    Her finner du verktøy og informasjon om hvordan systemet skal brukes. Blant annet
                    kan du se korte filmsnutter som viser hvordan du skal klassifisere med HRCS.
                </PageIntroduction>

                <FocusMenu>
                    <Button href="#veiledninger">Veiledninger</Button>
                    <Button href="#opplaringsvideoer">Opplæringsvideoer</Button>
                    <Button href="#hva-er-hrcs">Hva er HRCS</Button>
                    <Button href="#nyttig-informasjon">Informasjon og skjemaer</Button>
                    <Button href="/faq" disabled={true} title="Vil bli tilgjengelig etter hvert som det dukker opp spørsmål.">Ofte stilte spørsmål</Button>
                    <Button href="#kontaktpersoner">Kontaktpersoner</Button>
                </FocusMenu>

                <div className="content">
                    <h2 id="veiledninger">Veiledninger</h2>

                    <GridLayout>
                        <ImageButton
                            target="_blank"
                            image="/images/hurtigveiledning.png"
                            href="/downloads/1.%20Hurtigveiledning%20forskningsaktivitet%20og%20helsekategorier.pdf"
                            title="HRCS-hurtigveiledning">
                            En relativt kortfattet oversikt over helsekategorier og forskningsaktiviteter både på norsk og engelsk. Den kan skrives ut på en A3-side.
                        </ImageButton>
                        <ImageButton
                            target="_blank"
                            image="/images/hrcs-common-mistakes.png"
                            href="/downloads/3.%20Common%20Mistakes%20HRCS.pdf"
                            title="HRCS common mistakes">
                            En oversikt noen feilmerkinger som lett kan gjøres når man klassifiserer prosjekter med HRCS
                        </ImageButton>
                        <ImageButton
                            target="_blank"
                            image="/images/hrcs-veiledning.png"
                            href="/downloads/2.%20HRCS%20veiledning.pdf"
                            title="HRCS-veiledning">
                            Komplett veiledning til alle helsekategoriene og forskningsaktivitetene på engelsk.
                        </ImageButton>
                    </GridLayout>

                    <p>
                        For dere som skal klassifisere med HRCS, anbefaler vi å skrive ut hurtigveiledningen med norske oversettelser.
                        Det kan også være lurt å ta en rask titt på dokumentet som heter «Common mistakes». Der vil du finne nyttige tips om hvordan du skal
                        tenke når du skal klassifisere med HRCS. I tillegg finnes det en detaljert veiledning på engelsk. Disse dokumentene finner du i  listen over &mdash; klikk på bildet for å laste ned dokumentene.
                    </p>

                    <h2 id="opplaringsvideoer">Opplæringsvideoer</h2>

                    <div className="VideoEmbed">
                        {
                            this.state.activeVideo.id ?
                                <iframe src={`https://player.vimeo.com/video/${this.state.activeVideo.id}?autoplay=${this.state.activeVideo.counter}${this.state.activeVideo.time ? `#t=${this.state.activeVideo.time}` : ''}`} height="360" frameBorder="0" allowFullScreen className="VideoEmbed" /> :null
                        }
                        {this.state.activeVideo.id && this.state.activeVideo.elements ? this.state.activeVideo.elements : ''}
                        <GridLayout>
                            <VideoButton href="https://vimeopro.com/mannavhuse/forskningsradet-hrcs/video/239772394" title="Hvorfor er HRCS viktig?" thumbnail="/images/vimeo-hvorfor-er-det-viktig.jpg" onClick={() => this.toggleActiveVideo('239772394')} />
                            <VideoButton href="https://vimeopro.com/mannavhuse/forskningsradet-hrcs/video/239772404" title="Hvordan bruke HRCS?" thumbnail="/images/vimeo-hva-er-det-egentlig.jpg" onClick={() =>this.toggleActiveVideo('239772404')}/>
                            <VideoButton href="https://vimeopro.com/mannavhuse/forskningsradet-hrcs/video/239772413" title="Klassifisering i praksis" thumbnail="/images/vimeo-hrcs-i-praksis.jpg" onClick={elements => this.toggleActiveVideo('239772413', elements)}>
                                <ul className="BoxList">
                                    <li><a href="#" onClick={event => { event.preventDefault(); this.setActiveVideoTime('0m31s'); }}>Intervju med en grunnforsker: 0:31</a></li>
                                    <li><a href="#" onClick={event => { event.preventDefault(); this.setActiveVideoTime('3m51s'); }}>Intervju med en klinisk forsker: 3:51</a></li>
                                    <li><a href="#" onClick={event => { event.preventDefault(); this.setActiveVideoTime('7m11s'); }}>Intervju med en helse- og omsorgstjenesteforsker: 7:11</a></li>
                                </ul>
                            </VideoButton>
                        </GridLayout>
                    </div>

                    <p>Se på filmsnuttene over for å få mer informasjon om hvordan du skal gå frem for å klassifisere med HRCS.</p>

                    <p>
                        I opplæringsvideoen «Klassifisering i praksis» har vi oppdaget at det gikk litt fort i svingene. Kåre Birger Hagens
                        forskning skulle også vært klassifisert med helsekategorien «Betennelse og immunsystemet».
                        Riktig klassifisering vil da være 50 % «Muskel og skjelett» og 50 % «Betennelse og immunsystemet».
                    </p>

                    <h2 id="hva-er-hrcs">Alt om HRCS</h2>

                    <MediaObject title="Hva er HRCS?" image="/images/hrcs-online.png" imageHref="http://www.hrcsonline.net" target="hrcsonline">
                        HRCS er opprinnelig utviklet i England. På den engelske nettsiden finner du mer informasjon om selve systemet og også om de ulike kategoriene. Skal du bruke HRCS, anbefaler vi deg å ta en titt på <a href="http://www.hrcsonline.net/">HRCS Online</a>.
                    </MediaObject>

                    <h3>På de engelske nettsidene kan du lese mer om</h3>

                    <ul className="BoxList">
                        <li><a href="https://hrcsonline.net/getting-started/purpose-of-the-hrcs/" target="hrcsonline"><strong>Kort introduksjon til HRCS </strong> &mdash; Introduction to the HRCS</a></li>
                        <li><a href="https://hrcsonline.net/getting-started/general-approach-to-coding/" target="hrcsonline"><strong>Hvordan gå frem når du skal klassifisere</strong> &mdash; Approach to coding</a></li>
                        <li><a href="https://hrcsonline.net/health-categories/" target="hrcsonline"><strong>Helsekategoriene</strong> &mdash; Health categories</a></li>
                        <li><a href="https://hrcsonline.net/research-activities/" target="hrcsonline"><strong>Forskningsaktivitetene</strong> &mdash; Research activity codes</a></li>
                        <li><a href="https://hrcsonline.net/guidance/" target="hrcsonline"><strong>Hvordan klassifisere ulike temaer med HRCS</strong> &mdash; Guidance topics</a></li>
                    </ul>

                    <h2 id="nyttig-informasjon">Utprøvende kartlegging 2017 — retninglinjer for rapportering</h2>

                    <ul>
                        <li><a href="/downloads/HRCS%20rapporteringsskjema%20til%20NIFU.xlsx" target="_blank">Rapporteringsskjema til NIFU</a></li>
                        <li><a href="/downloads/HRCS_hjelpeskjema_AHUS.xlsx" target="_blank">Hjelpeskjema i Excel &mdash; brukes ved Akershus universitetssykehus (Ahus-modellen)</a></li>
                        <li><a href="/downloads/Notat%20fra%20Arbeidsgruppen%20for%20bruk%20av%20HRCS%20ved%20institusjonene.pdf" target="_blank">Notat fra Arbeidsgruppen for bruk av HRCS ved institusjonene &mdash; framgangsmåter og metodikk</a></li>
                        <li><a href="/downloads/Notat%20fra%20NIFU%20om%20FoU-statistisk%20metode%20i%20universitets-%20og%20høgskolesektoren.pdf" target="_blank">Notat fra NIFU om FoU-statistisk metode i universitets- og høgskolesektoren</a></li>
                        <li><a href="/downloads/Brev%20fra%20HOD%20og%20KD.pdf" target="_blank">Brev fra HOD og KD</a></li>
                    </ul>

                </div>
            </div>
        );
    }

    setActiveVideoTime(time) {
        this.setState(prevState => {
            return {
                activeVideo: {
                    ...prevState.activeVideo,
                    time: time,
                    counter: prevState.activeVideo.counter + 1
                }
            }
        });
    }

    toggleActiveVideo(videoId, elements = null) {
        this.setState(prevState => {
            return {
                activeVideo: {
                    ...prevState.activeVideo,
                    id: prevState.activeVideo.id === videoId ? null : videoId,
                    time: null,
                    elements: elements,
                }
            }
        });
    }
}



// WEBPACK FOOTER //
// ./src/HomePage/index.js